// @flow
import React from 'react';
import DatePicker from 'react-datepicker';
import { withTranslation, WithTranslation } from 'react-i18next';
import 'react-datepicker/dist/react-datepicker.css';
import moment from 'moment';
import Wrapper from './FormFieldWrapper';

type InputProps = {
  value: string,
  name: string,
  label: string,
  onChange: (number: string) => void,
  onChangeRaw: (e: SyntheticEvent) => any,
  className: string,
  required: boolean,
  type: string,
  error: string,
  helpText: string,
  format: string,
  dob: boolean,
  children: any,
  disabled: boolean,
  helpTextBelow: boolean /* default: help text hovers to right until bmobile breakpoint.
  adding this makes it below form always */
} & WithTranslation

type State = {
  showHelpText: boolean
}

class DateInput extends React.Component<InputProps, State> {
  state: State = {
    showHelpText: false
  };

  props: InputProps

  render() {
    const { value, dob, i18n, t } = this.props;
    const date = (value && moment(value, 'YYYY-MM-DD').isValid()) ?
      moment(value, 'YYYY-MM-DD') :
      null;
    const maxdate = dob ? moment().subtract(18, 'years') : moment();
    const mindate = moment().subtract(120, 'years');
    const [selectMode, myCalendar] = ['select', 'my-calendar-classname'];
    return (
      <Wrapper
        showHelpText={this.state.showHelpText}
        helpText={this.props.children}
      >
        <label className='control has-float-label' htmlFor={this.props.name}>
          <DatePicker
            name='datePicker'
            id='datePicker'
            selected={date}
            locale={i18n.language}
            placeholder={t('date')}
            onChange={this.props.onChange}
            onChangeRaw={this.props.onChangeRaw}
            showMonthDropdown
            showYearDropdown
            dropdownMode={selectMode}
            dateFormat='YYYY-MM-DD'
            className={`
              input 
              my-classname 
              ${this.props.disabled && 'is-disabled'}
              `}
            minDate={mindate}
            maxDate={maxdate}
            activeStartDate={maxdate}
            calendarClassName={myCalendar}
            required
            disabled={this.props.disabled}
            placeholderText='YYYY-MM-DD'
          />

          <span className='label-text'>{this.props.label}</span>
          {this.props.error ? <p className='error-text'>{this.props.error}</p> : ''}

        </label>
      </Wrapper>
    );
  }
}

export default withTranslation('dateInput')(DateInput);



// WEBPACK FOOTER //
// ./src/components/shared/DateInput.js